import { Loader2 } from "lucide-react";
import { Button, ButtonProps } from "./button";
import { cn } from "@/lib/utils";

interface ButtonLoadingProps extends ButtonProps {
  isLoading?: boolean;
}

export const ButtonLoading = (props: ButtonLoadingProps) => {
  const { children, isLoading, className, ...rest } = props;
  return (
    <Button
      className={cn("relative", className)}
      {...rest}
      disabled={isLoading || rest.disabled}
    >
      <span
        className="inline-flex items-center"
        style={{ visibility: isLoading ? "hidden" : "visible" }}
      >
        {children}
      </span>
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
          className="bg-rd-500"
        >
          <Loader2 className="h-4 w-4 animate-spin" />
        </div>
      )}
    </Button>
  );
};
